import React from 'react';
import {Play} from 'lucide-react';
import styles from '../../styles/components/DemoPlaceholder.module.css';

interface DemoPlaceholderProps {
  aspectRatio?: string;
  className?: string;
}

const DemoPlaceholder: React.FC<DemoPlaceholderProps> = ({aspectRatio, className}) => {
  return (
    <div
      className={`${styles.wrapper}${className ? ` ${className}` : ''}`}
      style={aspectRatio ? {aspectRatio} : undefined}
    >
      <Play size={40} className={styles.icon} />
      <p className={styles.label}>Demo coming soon</p>
    </div>
  );
};

export default DemoPlaceholder;
